import Vue from "vue"

const state = {

}

const mutations = {

}

const actions = {
    async fetchAreas({ dispatch }) {
        const { data, status } = await Vue.axios.get("/area");
        if (status != 200) {
            await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
        };
        return { data, status };
    },
    async createArea({ dispatch }, area) {
        const formData = new FormData();
        formData.append('icon', area.icon);
        formData.append('text', area.text);
        formData.append('urlText', area.urlText);
        formData.append('description', area.description);
        const { data, status } = await Vue.axios.post("/area", formData);
        if (status != 200 && status != 201) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error guardando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async updateArea({ dispatch }, area) {
        const formData = new FormData();
        formData.append('text', area.text);
        formData.append('urlText', area.urlText);
        formData.append('description', area.description);
        if(area.file) {
            formData.append('file', area.file)
        }
        const { data, status } = await Vue.axios.post(`/area/${area.id}`, formData);
        if (status != 200 && status != 201 && status != 204) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error actualizando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async removeArea({ dispatch }, area) {
        const { data, status } = await Vue.axios.delete(`/area/${area.id}`);
        if (status != 200 && status != 204) {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Ocurrió un error eliminando al rubro del sistema', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Rubro eliminado correctamente', type: 'success' })
        }
        return { data, status };
    }
}

export default { state, mutations, actions }